import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Vehicle.Details.IRequest;
type Response = Api.Core.Vehicle.Details.IResponse;
type Headers = Api.Core.Vehicle.Details.IHeaders;
const url = '/api/Sales/Sales/VehicleDetails';
export default async function vehicleDetailsApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
    tryParse: true,
  });
}
